import React from 'react'
import Squares from './SquareBackground'
import { BlurText } from './BlurText'
import StarBorder from './StartBorder'
import { HoverEffect } from './HoverEffect'
import { projects } from '../lib/constant'
import Watermark from './Watermark'

function Introduction() {
    const text = "React Animation Example"
    const subDesc = "'React Animation Example' demonstrates how to implement animations in a React application. It showcases techniques for adding motion and transitions to UI components, enhancing the visual appeal and user experience through smooth and responsive animations. This example helps developers understand how to integrate animations seamlessly into React projects using libraries or CSS."
    return (

        <div className='w-screen bg-[#1e1e1e] h-screen flex relative flex-col items-center justify-center'>
            <div className='absolute z-30 left-2 top-2'>
                <Watermark/>
            </div>
            <div className='w-full h-full absolute top-0'>
                <Squares
                    className='opacity-50'
                    speed={0.5}
                    size={40} 
                    direction='up' 
                    borderColor='#fff'
                    hoverFillColor='#222'
                />
            </div>

            <div className='w-full lg:max-w-[1200px] z-20  h-screen overflow-auto no-scrollbar '>
                <div className='h-fit flex flex-col items-center justify-center gap-3 lg:gap-6 px-2 pt-12 md:pt-9'>
                    <BlurText text={text} className="font-bold text-center text-4xl xl:text-6xl" delay={50} />
                    <div className='w-full'>
                        <StarBorder
                            as="div"
                            className=""
                            color="white"
                            speed="5s"
                        >
                            <BlurText text={subDesc} className="text-justify md:text-center text-sm md:text-xl" delay={50} />
                        </StarBorder>
                    </div>
                    <div className="">
                        <HoverEffect items={projects} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Introduction
